export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapSignals';
export const ENTITY_EDIT_ROUTE = 'signals/intersections';
